var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "portal",
    { attrs: { to: "modal" } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isModalVisible
          ? _c(
              "div",
              {
                staticClass: "i-modal",
                style: _vm.style,
                on: {
                  mousedown: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    $event.stopPropagation()
                    return _vm.onBackgroundClick.apply(null, arguments)
                  },
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                  touchstart: function ($event) {
                    $event.stopPropagation()
                  },
                  scroll: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [_vm._t("default")],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }